module.exports = __webpack_public_path__ + "static/media/original_price.81b8d1ba.svg";